import { createRoot } from 'react-dom/client';

import 'src/assets/styles/index.scss';
import 'src/config/yup.config';

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
